import { ReactNode } from "react";
import {
  IconButton,
  Box,
  Flex,
  Icon,
  useColorModeValue,
  Link,
  Drawer,
  DrawerContent,
  useDisclosure,
  BoxProps,
  FlexProps,
  Image,
} from "@chakra-ui/react";
import { FiMenu, FiUser, FiPackage, FiGlobe, FiFolder, FiCornerDownLeft } from "react-icons/fi";
import { IconType } from "react-icons";
import { ReactText } from "react";
import theme from "../../../styles/theme";
import { useNavigate } from "react-router-dom";

interface LinkItemProps {
  name: string;
  icon: IconType;
  to: string;
  color: string;
}
const LinkItems: Array<LinkItemProps> = [
  {
    name: "CATEGORIAS",
    icon: FiFolder,
    to: "/dashboard/categories",
    color: "telegram.600",
  },
  {
    name: "PRODUTOS",
    icon: FiPackage,
    to: "/dashboard/products",
    color: "telegram.600",
  },
  {
    name: "COMPANHIAS",
    icon: FiGlobe,
    to: "/dashboard/companies",
    color: "telegram.600",
  },
  {
    name: "USUÁRIOS",
    icon: FiUser,
    to: "/dashboard/users",
    color: "telegram.600",
  },
  { name: "VER SITE", icon: FiCornerDownLeft, to: "/", color: "telegram.600" },
];

const logo = require("../../../assets/Logo.png");

export default function SimpleSidebar({ children }: { children: ReactNode }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <Box color="white" minH="100vh" bg="#0d1b33">
      <SidebarContent onClose={() => onClose} display={{ base: "none", md: "block" }} />
      <Drawer
        autoFocus={false}
        isOpen={isOpen}
        placement="left"
        onClose={onClose}
        returnFocusOnClose={false}
        onOverlayClick={onClose}
        size="full"
      >
        <DrawerContent>
          <SidebarContent onClose={onClose} />
        </DrawerContent>
      </Drawer>
      {/* mobilenav */}
      <MobileNav display={{ base: "flex", md: "none" }} onOpen={onOpen} />
      <Box ml={{ base: 0, md: 60 }} p="4" bg={"#0d1b33"}>
        {children}
      </Box>
    </Box>
  );
}

interface SidebarProps extends BoxProps {
  onClose: () => void;
}

const SidebarContent = ({ onClose, ...rest }: SidebarProps) => {
  return (
    <Box
      bg={"#152747"}
      color={theme.colors.white}
      fontWeight="bold"
      shadow={"2xl"}
      w={{ base: "full", md: 60 }}
      pos="fixed"
      h="full"
      {...rest}
    >
      <Flex h="20" alignItems="center" mx="8" mb="8" justifyContent="space-between">
        <Image src={logo} />
      </Flex>
      {LinkItems.map((link) => (
        <NavItem color={link.color} key={link.name} icon={link.icon} to={link.to}>
          {link.name}
        </NavItem>
      ))}
    </Box>
  );
};

interface NavItemProps extends FlexProps {
  icon: IconType;
  children: ReactText;
  to: string;
  color: string;
}
const NavItem = ({ color, to, icon, children, ...rest }: NavItemProps) => {
  const navigate = useNavigate();
  return (
    <Link
      onClick={() => navigate(to)}
      style={{ textDecoration: "none" }}
      _focus={{ boxShadow: "none" }}
    >
      <Flex
        align="center"
        p="4"
        mx="4"
        borderRadius="lg"
        role="group"
        cursor="pointer"
        _hover={{
          bg: color,
          color: "white",
        }}
        {...rest}
      >
        {icon && (
          <Icon
            mr="4"
            fontSize="16"
            _groupHover={{
              color: "white",
            }}
            as={icon}
          />
        )}
        {children}
      </Flex>
    </Link>
  );
};

interface MobileProps extends FlexProps {
  onOpen: () => void;
}
const MobileNav = ({ onOpen, ...rest }: MobileProps) => {
  return (
    <Flex
      ml={{ base: 0, md: 60 }}
      px={{ base: 4, md: 24 }}
      height="20"
      alignItems="center"
      bg={useColorModeValue("white", "gray.900")}
      borderBottomWidth="1px"
      borderBottomColor={useColorModeValue("gray.200", "gray.700")}
      justifyContent="flex-start"
      {...rest}
    >
      <IconButton variant="outline" onClick={onOpen} aria-label="open menu" icon={<FiMenu />} />

      <Image src={logo} />
    </Flex>
  );
};
